import { useEffect, useState } from "react";
import PaymentService from "../../services/PaymentService";
import Header from "../../components/Header";
import CustomerService from "../../services/CustomerService";
import ServicesService from "../../services/ServicesService";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { notification } from "antd";
import { useNavigate, useParams } from "react-router-dom";
import CryptoJS from "crypto-js";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import { ThreeDots } from "react-loader-spinner";
import Lodder from "../../components/Lodder";
const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};
const fieldStyles = {
  border: "1px solid #dee2e6",
  "border-radius": "0.25rem",
  color: "rgb(26, 32, 44)",
  "font-weight": 400,
  height: "38px",
  width: "100%",
  "font-size": "14px",
  padding: "6px 12px",
};
const Payment = () => {
  const [name, setName] = useState('');
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => {
    setOpen(false);
    localStorage.setItem('pop','1')
    navigate("/dashboard");
  };

  const [submit, setSubmit] = useState(true);
  const navigate = useNavigate();
  const encryptedQueryParam = useParams().userData;
  const decryptedData = CryptoJS.AES.decrypt(
    decodeURIComponent(encryptedQueryParam),
    process.env.REACT_APP_SECRET_KEY
  ).toString(CryptoJS.enc.Utf8);
  const customerData = JSON.parse(decryptedData);

  const handleChange = (change) => {
    setState(change.state);
  };
  const [paymentToken, setPaymentToken] = useState(null);
  const [state, setState] = useState(null);
  const [feild, setFeild] = useState(true);
  const [amount, setAmount] = useState(550);
  useEffect(() => {
    window.scrollTo(0, 0);
    PaymentService.CreatePaymentToken().then((response) => {
      setPaymentToken(response);
    });
    document.title = "Payment Process"
    ServicesService.GetServiceByServiceName(2)
      .then((response) => {
        if (response.status) {
          setAmount(Math.floor(response.resultData.price))
        }
      })
      .catch((error) => {
        /* toast.error(error, {
          position: "top-center",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        }); */
        notification.error({
          message: error,
        });
      })
  }, []);

  const handleSubmit = () => {
     
    setSubmit(false);
    // eslint-disable-next-line no-restricted-globals
    event.preventDefault();
    if (state.initializing) {
      setSubmit(true);
      return;
    }
    window.gravityLegal.submitFields(async (err) => {
      setSubmit(false);
      if (err) {
        /* toast.error(`${err.fieldId} ${err.result}`, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        }); */
        notification.error({
          message: `${err.fieldId} ${err.result}`,
        });
        setSubmit(true);
        return;
      }
      const Payment = {
        amount: amount,
        paymentMethod: state.paymentMethod,
        paymentToken,
      };
      PaymentService.RunPayment(Payment).then((response) => {
        setSubmit(false);
        if (response.data.data != null) {
          if (response.data.data.runPayment.status === "success") {
            const customerPaymentDetail = {
              paymentId: response.data.data.runPayment.id,
              status: true,
              amount:
                response.data.data.runPayment.transactions[0].amountProcessed,
              transactionId: response.data.data.runPayment.transactions[0].id,
              userId: customerData.userId,
              name: name,
              customerBusinessId:customerData.customerBusinessId
            };
             
            CustomerService.AddCustomerPaymentDetail(
              customerPaymentDetail
            ).then((response) => {
              if (response.status) {
                const customerCredentials = {
                  email: customerData.email,
                  password: customerData.password,
                };
                CustomerService.LoginCustomer(customerCredentials).then(
                  (response) => {
                    localStorage.setItem(
                      "accessToken",
                      response.resultData.token
                    );
                    handleOpen();
                  }
                );
                /* setTimeout(() => {
                  navigate("/dashboard");
                }, 2000);
                console.log(response); */
              }
            });

          } else {
            setSubmit(true);
          }
        } else {
          setSubmit(true);
        }
      });
      setSubmit(true);
    });
    setSubmit(true);
  };
  window.gravityLegal.addChangeListener((event) => {
    if (event.type === "fields_loaded") {
      setFeild(false);
    }
    handleChange(event)
  });

  useEffect(() => {
    // Initialize the payment form when the payment token is available
    if (paymentToken) {
      window.gravityLegal.init({
        paymentToken,
        activeForm: "card",
        fields: {
          cardNumber: {
            containerId: "card-number",
            style: fieldStyles,
          },
          cardExpirationDate: {
            containerId: "card-exp",
            style: fieldStyles,
          },
          cardSecurityCode: {
            containerId: "card-cvv",
            style: fieldStyles,
          },
        },
      });
    }
  }, [paymentToken]);

  const handleBack = () => {
     ;
    navigate(`/register/${customerData.userId}`);
  }

  return (
    <>
      <Lodder show={!submit} />
      <ToastContainer />
      <Header />
      <main>
        <div className="my-5 pt-5 login-form ">
          <div className="mx-auto payment-card card mt-2 border-0 shadow mt-4">
            <div className="container card-body ">
              <div className="row">
                <div className="col-12">
                  <figure className="text-center mx-auto mb-0">
                    {/* <img
                      src="/logo.png"
                      className="img-fluid"
                      alt="foundary logo"
                      style={{ width: 60 }}
                    /> */}
                  </figure>
                  <h5 className="card-title mt-3 text-center mb-3 w-100">
                    Payment Process
                  </h5>
                </div>
              </div>
            </div>
            <div
              className="p-2 text-center"
              style={{ backgroundColor: "rgb(234, 103, 35)" }}
            >
              <p className="payment-heading">Payment Amount</p>
              <p className="payment-title">${amount}.00</p>
            </div>
            <div className="container">
              <div className="row card-payment">
                <div className="col-12">
                  <form className="row">
                    {/* <div className="mb-3 col-lg-12">
                <label className="form-label fw-bold">Payment Method</label>
                <div className="d-flex">
                  <div className="form-check me-5">
                    <input
                      className="form-check-input"
                      type="radio"
                      name="flexRadioDefault"
                      id="flexRadioDefault1"
                    />
                    <label
                      className="form-check-label"
                      htmlFor="flexRadioDefault1"
                    >
                      Debit/Credit Card
                    </label>
                  </div>
                  <div className="form-check">
                    <input
                      className="form-check-input"
                      type="radio"
                      name="flexRadioDefault"
                      id="flexRadioDefault2"
                      defaultChecked=""
                    />
                    <label
                      className="form-check-label"
                      htmlFor="flexRadioDefault2"
                    >
                      Bank Transfer (ACH)
                    </label>
                  </div>
                </div>
              </div> */}
                    <div className="mb-3 col-lg-12">
                      <label className="form-label">Name on card</label>
                      <input className="form-control rounded-1" type="text" value={name} onChange={(event) => { setName(event.target.value) }} />
                    </div>
                    <div className="mb-3 col-lg-12">
                      <label className="form-label">Card number</label>
                      {/* <input className="form-control rounded-1" type="text" /> */}
                      <div className="payment-input" id="card-number">
                        <ThreeDots
                          visible={feild}
                          height="20"
                          width="50"
                          color="rgb(72,72,72)"
                          radius="9"
                          ariaLabel="three-dots-loading"
                          wrapperStyle={{}}
                          wrapperClass=""
                        />
                      </div>
                    </div>
                    <div className="mb-3 col-lg-6">
                      <label className="form-label">Expiration date</label>
                      {/* <input className="form-control rounded-1" type="text" /> */}
                      <div className="payment-input" id="card-exp">
                        <ThreeDots
                          visible={feild}
                          height="20"
                          width="50"
                         color="rgb(72,72,72)"
                          radius="9"
                          ariaLabel="three-dots-loading"
                          wrapperStyle={{}}
                          wrapperClass=""
                        />
                      </div>
                    </div>
                    <div className="mb-3 col-lg-6">
                      <label className="form-label">CVV</label>
                      {/* <input className="form-control rounded-1" type="text" /> */}
                      <div className="payment-input" id="card-cvv">
                        <ThreeDots
                          visible={feild}
                          height="20"
                          width="50"
                           color="rgb(72,72,72)"
                          radius="9"
                          ariaLabel="three-dots-loading"
                          wrapperStyle={{}}
                          wrapperClass=""
                        />
                      </div>
                    </div>
                    <div className="border-0 text-center d-flex justify-content-end mt-3 mb-2">
                      {/* {submit ? (
                        <button
                          type="submit"
                          className="btn btn-primary d-block submit-button w-100"
                          onClick={handleSubmit}
                        >
                          Complete Payment
                        </button>
                      ) : (
                        <button
                          type="submit"
                          className="btn btn-primary d-block submit-button w-100"
                          onClick={handleSubmit}
                          disabled
                        >
                          Complete Payment
                        </button>
                      )} */}
                      <button
                        type="submit"
                        className="btn btn-primary d-block submit-button w-100 me-2"
                        onClick={handleBack}
                        disabled
                      >
                        BACK
                      </button>

                      <button
                        type="submit"
                        className="btn btn-primary d-block submit-button w-100"
                        onClick={handleSubmit}
                      >
                        COMPLETE PAYMENT AND SUBMIT
                      </button>
                      {/*  <button
                        type="submit"
                        className="btn btn-primary d-block submit-button w-100"
                        onClick={handleSubmit}
                      >
                        Complete Payment
                      </button> */}
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>

      {/* <Footer /> */}
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Typography id="modal-modal-title" variant="h6" component="h2">
            Payment successful
          </Typography>
          <Typography id="modal-modal-description" sx={{ mt: 2 }}>
            <Button className="submit-button"onClick={handleClose}>OK</Button>
          </Typography>
        </Box>
      </Modal>
      {/*  <div id="form-tabs">
    <div className="flex flex-col gap-y-4">
      <h3 className='text-lg font-semibold'>Enter test card info</h3>
      <div className="h-12 outline outline-1 outline-gray-300 rounded-md" id="card-number"></div>
      <div className="h-12 outline outline-1 outline-gray-300 rounded-md" id="card-exp"></div>
      <div className="h-12 outline outline-1 outline-gray-300 rounded-md" id="card-cvv"></div>
    </div>
    <button className='bg-blue-500 hover:bg-blue-400 py-2 px-6 rounded text-white' id='submit-button'  onClick={handleSubmit}>Pay</button>
  </div> */}

    


    </>
  );
};

export default Payment;
